import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string | JSX.Element;
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'Do you provide mobile tinting in Ellicott City?',
      answer: (
        <>
          Yes! Our <a href="/mobile-tinting" className="text-teal-600 hover:text-teal-700 font-medium">mobile window tinting service</a> comes directly to your home or office in Ellicott City. No need to travel - we bring the shop to you!
        </>
      ),
    },
    {
      question: 'What window tinting services are available in Ellicott City?',
      answer: (
        <>
          We offer <a href="/window-tinting" className="text-teal-600 hover:text-teal-700 font-medium">premium ceramic and standard tinting</a>, <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial property tinting</a>, <a href="/headlight-taillight-tinting" className="text-teal-600 hover:text-teal-700 font-medium">light tinting</a>, and <a href="/vehicle-decals" className="text-teal-600 hover:text-teal-700 font-medium">custom vehicle graphics</a>.
        </>
      ),
    },
    {
      question: 'How much does window tinting cost in Ellicott City?',
      answer: 'Pricing depends on your vehicle type and tint choice. We offer competitive rates for both standard and ceramic tinting. Contact us for a free, no-obligation quote for your specific vehicle.',
    },
    {
      question: 'Is window tinting legal in Ellicott City, Maryland?',
      answer: 'Yes! Window tinting is legal in Maryland with specific requirements. Front side windows must allow more than 35% light transmission. We ensure all installations comply with Maryland tinting laws.',
    },
    {
      question: 'Why choose ceramic tint over standard tint?',
      answer: 'Ceramic tint provides superior heat rejection, blocks 99% of harmful UV rays, never fades or turns purple, and doesn\'t interfere with GPS, radio, or phone signals. It\'s the premium choice for maximum comfort and protection.',
    },
    {
      question: 'What areas of Ellicott City do you serve?',
      answer: 'We serve all of Ellicott City including Historic District, Enchanted Forest, Turf Valley, Centennial, and surrounding Howard County areas. Our mobile service makes it convenient no matter where you are.',
    },
    {
      question: 'Do you offer a warranty on your tinting?',
      answer: 'Absolutely! All our window tinting comes with a lifetime warranty against peeling, bubbling, fading, and discoloration. We stand behind our workmanship 100%.',
    },
    {
      question: 'Can you tint commercial buildings in Ellicott City?',
      answer: (
        <>
          Yes! We provide <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial window tinting</a> for businesses, offices, and storefronts in Ellicott City. Commercial tinting improves energy efficiency and adds privacy.
        </>
      ),
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about our window tinting services in Ellicott City
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors flex items-center justify-between cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-teal-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 py-4 bg-gray-50 text-gray-700 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Still have questions? We're here to help!
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
